import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLElement.prototype);

function translateTo(el, translate, opacity, speed, delay, easing) {
	var ease = easing || 'ease';
	var transition = 'transform ' + speed + 's ' + ease + ' ' + delay + 's,' +
		'opacity ' + speed + 's ' + ease + ' ' + delay + 's';

	if (!el || !el.style) return; // hi microsoft edge

	el.style.transition =
	el.style.webkitTransition = transition;

	el.style.transform =
	el.style.webkitTransform = 'translateY(' + translate + 'px)';

	el.style.opacity = opacity;
}

var _show = function() {
	// var self = this;

	// if (this._visible) return;
	// this._visible = true;

	// this.style.opacity = 1;
	// this.style.pointerEvents = 'auto';

	// Array.prototype.forEach.call(this._lines, function(ln, index) {
	// 	translateTo(ln, -20, 0, 0, 0);
	// });
	// setTimeout(function() {
	// 	Array.prototype.forEach.call(self._lines, function(ln, index) {
	// 		translateTo(ln, 0, 1, 0.3, index * 0.1, 'cubic-bezier(0.25, 0.46, 0.45, 0.94)');
	// 	});
	// });
}

var _hide = function() {
	// if (!this._visible) return;
	// this._visible = false;

	// this.style.pointerEvents = 0;
	// Array.prototype.forEach.call(this._lines, function(ln, index) {
	// 	translateTo(ln, 20, 0, 0.3, index * 0.1, 'cubic-bezier(0.46, 0.04, 0.66, 0.32)');
	// });
}

elementProto.createdCallback = function() {
	// this.show = _show.bind(this);
	// this.hide = _hide.bind(this);
	// this._visible = true;
}
elementProto.attachedCallback = function() {
	// if (!this.classList.contains('active')) {
	// 	this.style.opacity = 0;
	// 	this._visible = false;
	// }

	// this._lines = this.getElementsByClassName('ln');
}
elementProto.detachedCallback = function() {
}

document.registerElement('report-slide', {
	prototype: elementProto
});